window.addEventListener('DOMContentLoaded', () => {
  const $footer = document.querySelector('#footer');
  if (!$footer) return;

  const $familySite = $footer.querySelector('.family-site');
  if ($familySite) {
    const $toggle = $familySite.querySelector('.toggle');
    window.addEventListener('click', (e) => {
      if (e.target.closest('.toggle') === $toggle) {
        $familySite.classList.toggle('--active');
      } else {
        $familySite.classList.remove('--active');
      }
    });
  }

  const $langs = $footer.querySelector('.langs');
  if ($langs) {
    const $toggle = $langs.querySelector('.toggle');
    window.addEventListener('click', (e) => {
      if (e.target.closest('.toggle') === $toggle) {
        $langs.classList.toggle('--active');
      } else {
        $langs.classList.remove('--active');
      }
    });
  }

  // 언어 전환 기능 국/영
  const $btnKo = $footer.querySelector('.langs .lang-ko');
  const $btnEn = $footer.querySelector('.langs .lang-en');
  const currentUrl = window.location.pathname;

  // 🇰🇷 한국어 버튼 클릭 시
  $btnKo?.addEventListener('click', (e) => {
    e.preventDefault();
    if (currentUrl.startsWith('/en')) {
      const newUrl = currentUrl.replace(/^\/en/, '') || '/';
      window.location.href = newUrl;
    }
  });

  // 🇺🇸 영어 버튼 클릭 시
  $btnEn?.addEventListener('click', async (e) => {
    e.preventDefault();

    if (!currentUrl.startsWith('/en')) {
      // 현재 페이지의 영문 지원 여부 체크
      if (currentUrl && currentUrl !== '/') {
        // URL 경로를 번역 파일 경로로 변환
        // 예: /company/introduction.do -> company/introduction
        let translationPath = currentUrl.replace(/^\//, '').replace(/\.do$/, '').replace(/\/$/, '');

        try {
          const response = await fetch(`/assets/js/src/i18n/${translationPath}.json`);
          // 번역 파일이 없는 경우
          if (!response.ok) {
            const confirmed = confirm('영문에서는 지원하지 않는 페이지입니다. 메인으로 이동하시겠습니까?');
            if (confirmed) window.location.href = '/en/';

            return;
          }
        } catch (error) {
          console.warn('[i18n] Error checking translation file:', error);
        }
      }

      // 영문 지원 페이지인 경우 이동
      const newUrl = `/en${currentUrl}`;
      window.location.href = newUrl;
    }
  });
});
